/**
 * Replace broken images with a placeholder
 */
export default function fmImageError() {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      // replace image src with the given value
      element.bind('error', () => {
        let fallback = attrs.fmImageError || require('../img/article-cover.png');
        if (attrs.src != fallback) {
          attrs.$set('src', fallback);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/directives/image_error.js